import SamanthaHeadshot from '../Media/SamanthaHeadshot.png';
import AlexaHeadshot from '../Media/AlexaHeadshot.png';

export const MidCityBoard = [
  {
    id: "samantha",
    name: "Samantha",
    image: SamanthaHeadshot,
    description: "4th Year",
    major: "Civil Engineering",
  },

  {
    id: "alexa",
    name: "Alexa",
    image: AlexaHeadshot,
    description: "2nd Year",
    major: "Civil Engineering",
  },

];